import { LoginRequestBody } from '@easeltv/client-sdk';
import { Link, useLocation } from 'react-router-dom';

import { Field } from '../../../providers/RegistrationProvider/RegistrationProvider.helpers';
import FormBlock, { SetErrorFn } from '../../Blocks/FormBlock';
import RegistrationHeadingSection from '../../Sections/RegistrationHeadingSection';
import { P } from '../../typography';
import {
    OtherRegOption,
    StyledRegistrationTemplate,
} from '../RegistrationTemplate/RegistrationTemplate.styled';

/* ---------------------------------- Type ---------------------------------- */

export interface DumbSignInTemplateI {
    labels: {
        /** Disclaimer link text */
        disclaimerLabel: string;

        /** Disclaimer text with placeholder to be replaced with a link */
        disclaimerText: string;

        /** Disclaimer link URL */
        disclaimerUrl: string;

        /** Page heading body text */
        headingBody?: string;

        /** Page heading subtitle text */
        headingSubtitle?: string;

        /** Page heading title text */
        headingTitle?: string;

        /** Label value for the switch to register page button */
        registerButton: string;

        /** Title text for the switch to register page section */
        registerTitle: string;

        /** Text for form submit button */
        submitLabel: string;
    };

    /** Array of fields to render for this form */
    fields: Field[];

    /** Callback function to be called on submit */
    handleOnSubmit: (data: LoginRequestBody, setError: SetErrorFn) => void;

    /** Whether the switch to register page section should be shown */
    showOtherRegOption: boolean;

    disableRegistration: boolean;
}

/* -------------------------------- Component ------------------------------- */

/**
 * DumbSignInTemplate
 *
 * @param props DumbSignInTemplateI
 * @returns JSX.Element
 */
const DumbSignInTemplate = ({
    labels,
    fields,
    handleOnSubmit,
    showOtherRegOption,
    disableRegistration,
}: DumbSignInTemplateI) => {
    const location = useLocation();

    return (
        <StyledRegistrationTemplate>
            <RegistrationHeadingSection
                title={labels.headingTitle}
                subtitle={labels.headingSubtitle}
                body={labels.headingBody}
            />
            <FormBlock
                labels={{
                    disclaimer: {
                        label: labels.disclaimerLabel,
                        text: labels.disclaimerText,
                        url: labels.disclaimerUrl,
                    },
                    submitLabel: labels.submitLabel,
                }}
                fields={fields}
                handleOnSubmit={handleOnSubmit}
                validator={LoginRequestBody}
                forgotPassword={!disableRegistration}
            />
            {showOtherRegOption && (
                <OtherRegOption>
                    <P>{labels.registerTitle}</P>
                    <P>
                        <Link
                            to="/register"
                            // Pass state with the navigation so the pairing code or returnUrl are also passed if
                            // they are defined - Note: State may need to be passed as a prop, will discover come
                            // testing if jest complains
                            state={location.state}
                        >
                            {labels.registerButton}
                        </Link>
                    </P>
                </OtherRegOption>
            )}
        </StyledRegistrationTemplate>
    );
};
/* --------------------------------- Export --------------------------------- */

export default DumbSignInTemplate;
